let VIEW_VALUE_MAP = {
  loading: 'Loading',
  ready: 'Content',
  error: 'Error',
}

export function getView(value) {
  return VIEW_VALUE_MAP[value] || 'No'
}
